import { render, staticRenderFns } from "./BasicSelects.vue?vue&type=template&id=4cb3a456&"
import script from "./BasicSelects.vue?vue&type=script&lang=js&"
export * from "./BasicSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports